itsoftApp.createModule("videoload", function() {


    var source1 = "<video id='video' preload='auto' autoplay loop class='slide-1__video-box'> <source src='/media/video/video_bg.mp4' type='video/mp4'></video>";
    var source2 = "<video id='video2' preload='auto' autoplay loop class='slide-1__video-box'> <source src='/media/video/video2.mp4' type='video/mp4'></video>";
    var video1 = $(".video-box1");
    var video2 = $(".video-box2");

    function addVideo(box, content){
        box.html(content);
    }

    if (video1.length) {
        if (screen.width > 760) {
            setTimeout(addVideo(video1, source1), 0);

        }

    }

    if (video2.length) {
        if (screen.width > 760) {
            setTimeout(addVideo(video2, source2), 0);
        }

    }
});

